var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8022 18.7289C18.9113 18.6182 19.0887 18.6182 19.1979 18.7289L26.2519 25.8858C26.3605 25.9961 26.3605 26.1744 26.2519 26.2846L25.2795 27.2712C25.1703 27.3819 24.993 27.3819 24.8838 27.2712L19.1319 21.4354C19.0591 21.3615 18.9409 21.3615 18.8681 21.4354L13.1162 27.2711C13.0071 27.3819 12.8297 27.3819 12.7206 27.2711L11.7482 26.2846C11.6395 26.1744 11.6395 25.996 11.7482 25.8858L18.8022 18.7289Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigArrow);
export default __webpack_public_path__ + "static/media/BigArrow.ba29ccd28aeec263427fdb55f2739132.svg";
export { ForwardRef as ReactComponent };